(() => {
  const drawer = document.getElementById('MinimogCartDrawer');
  const host = drawer && drawer.querySelector('[data-minimog-cart-items]');
  if (!host) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cache = new Map();
  let lastKey = '';
  let busy = false;

  const fetchSection = (url) =>
    fetch(url, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const result = doc.querySelector('[data-ls-cart-recs-result]');
        return result && result.querySelector('.ls-cr-card') ? result.outerHTML : '';
      })
      .catch(() => '');

  const recsFor = (slot) => {
    const { product, intent, limit, fallback } = slot.dataset;
    const n = Number(limit) || 6;
    const recUrl = (kind) => `${root}recommendations/products?product_id=${product}&limit=${n + 4}&intent=${kind}&section_id=ls-cart-recs`;
    let chain = Promise.resolve('');
    if (product) {
      if (intent !== 'related') chain = chain.then((html) => html || fetchSection(recUrl('complementary')));
      if (intent !== 'complementary') chain = chain.then((html) => html || fetchSection(recUrl('related')));
    }
    if (fallback) chain = chain.then((html) => html || fetchSection(`${root}collections/${fallback}?section_id=ls-cart-recs`));
    return chain;
  };

  const setupNav = (slot) => {
    const list = slot.querySelector('[data-ls-cart-recs-list]');
    const nav = slot.querySelector('[data-ls-cart-recs-nav]');
    if (!list || !nav) return;
    const [prev, next] = nav.querySelectorAll('button');
    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
    };
    nav.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-dir]');
      if (!button) return;
      const card = list.querySelector('.ls-cr-card');
      const step = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.8;
      list.scrollBy({ left: step * Number(button.dataset.dir), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    list.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    requestAnimationFrame(update);
  };

  const paint = (slot, html) => {
    slot.innerHTML = html;
    slot.hidden = !html;
    if (html) setupNav(slot);
  };

  const sync = () => {
    const slot = host.querySelector('[data-ls-cart-recs]');
    if (!slot) return;
    const key = `${slot.dataset.product}|${slot.dataset.ids}`;
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (typeof cached === 'string') paint(slot, cached);
      return;
    }
    if (key === lastKey) return;
    lastKey = key;
    slot.hidden = true;
    cache.set(key, recsFor(slot).then((html) => {
      cache.set(key, html);
      const current = host.querySelector('[data-ls-cart-recs]');
      if (current && `${current.dataset.product}|${current.dataset.ids}` === key) paint(current, html);
      return html;
    }));
  };

  host.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ls-cart-recs-add]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    const label = button.textContent;
    const slot = button.closest('[data-ls-cart-recs]');
    const error = slot && slot.querySelector('[data-ls-cart-recs-error]');
    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = (slot && slot.dataset.adding) || label;
    fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.lsCartRecsAdd), quantity: 1 }] }),
    })
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        if (typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
        else window.location.reload();
      })
      .catch(() => {
        button.textContent = label;
        button.disabled = false;
        if (error) error.hidden = false;
      })
      .finally(() => {
        busy = false;
        button.removeAttribute('aria-busy');
      });
  });

  let armed = false;
  const shell = drawer.closest('m-cart-drawer') || drawer;
  const arm = () => {
    if (armed) return;
    armed = true;
    classWatch.disconnect();
    sync();
  };
  const classWatch = new MutationObserver(() => {
    if (shell.classList.contains('m-cart-drawer--active')) arm();
  });
  classWatch.observe(shell, { attributes: true, attributeFilter: ['class'] });
  const warm = (event) => {
    if (event.target.closest && event.target.closest('.m-cart-icon-bubble, [data-cart-drawer-toggle], a[href$="/cart"]')) arm();
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  new MutationObserver(() => { if (armed) sync(); }).observe(host, { childList: true });
  if (shell.classList.contains('m-cart-drawer--active')) arm();
})();
